import { HeroId } from "../../../../shared/src/index.ts";
import type { VoiceScript } from "../voice-types.ts";

const script = {
  hero: HeroId.NoonKnight,
  voices: {
    main: {
      description:
        "sun-baked vigilante baritone, fractured devotional intensity, desert-dry rasp, sudden prayer-like emphasis, close mic with hard daylight brightness",
      seed: 10541,
      guidance: 0.76,
      loudness: 0.78,
      fx: { eq: "warm", reverb: 0.12 },
    },
  },
  lines: {
    select: [
      {
        id: "select_1",
        text: "I tear through the cloudless night, just like the moon.",
      },
      { id: "select_2", text: "I'm Noon Knight… I think." },
      { id: "select_3", text: "Khonshu's avatar is here!" },
      { id: "select_4", text: "You got Noon Knight now." },
      { id: "select_5", text: "They want blood… but so do I." },
    ],
    spawn: [
      { id: "spawn_1", text: "Out of the dark and into the light!" },
      {
        id: "spawn_2",
        text: "Well, if it isn't my favorite travelers in the night!",
      },
      { id: "spawn_3", text: "There's no escaping Khonshu's wrath!" },
      { id: "spawn_4", text: "The hunt is on. Nice to have company for once." },
      {
        id: "spawn_5",
        text: "I'm Marc Spector, I'm Steven Grant, I'm Jake Lockley. And we are Noon Knight.",
      },
      {
        id: "spawn_6",
        text: "You guys are actually here, right? Or am I imagining this?",
      },
      {
        id: "spawn_7",
        text: "I wear white for a reason. I want the bad guys to see me coming.",
      },
      {
        id: "spawn_8",
        text: "I do hear voices in my head. You would too, if you listened.",
      },
      {
        id: "spawn_9",
        text: "There's a god living in my head, I… don't know what to think.",
      },
      {
        id: "spawn_10",
        text: "I'm used to fighting on the streets. Not across all space and time.",
      },
      {
        id: "spawn_11",
        text: "I like you. For now. But trust me, that could change in a heartbeat.",
      },
      {
        id: "spawn_12",
        text: 'Khonshu seems to be enjoying "the end of all that is" a bit too much…',
      },
      {
        id: "spawn_13",
        text: "Khonshu gave me my mission. And nothing's going to stop me from seeing it through.",
      },
      {
        id: "spawn_14",
        text: "Anyone who makes the night a more dangerous place needs to be taken out.",
      },
      {
        id: "spawn_15",
        text: "They don't believe you're real, Khonshu. I'll make sure they regret that…",
      },
      {
        id: "spawn_16",
        text: "Richards and Stark think they know everything. But when man plans, the gods laugh.",
      },
      {
        id: "spawn_17",
        text: "Either you're on my side or you're next in line to fall.",
      },
      {
        id: "spawn_18",
        text: "I'm the Fist of Khonshu, protector of the overnight travelers.",
      },
      { id: "spawn_19", text: "Khonshu has guided me this far. I trust him." },
      {
        id: "spawn_20",
        text: "Camouflage is stupid. I want the enemy to see me…and be afraid.",
      },
      { id: "spawn_21", text: "The moon gives me strength." },
      { id: "spawn_22", text: "Friends call me Marc… or Steven... or Jake." },
      {
        id: "spawn_23",
        text: "Being a living avatar of vengeance takes a lot out of a guy…",
      },
      {
        id: "spawn_24",
        text: "Khonshu guides me. Just… not always in the right direction…",
      },
      {
        id: "spawn_25",
        text: "Khonshu hates vampires. Which means I do, too.",
      },
      {
        id: "spawn_26",
        text: "The night won't be safe until these vamps are dust.",
      },
      {
        id: "spawn_27",
        text: "Enough talk. I'm ready to knock out some fangs.",
      },
      {
        id: "spawn_28",
        text: "Stopped Dracula once. This time, I'll make sure it sticks.",
      },
      { id: "spawn_29", text: "Dracula owes me. Time to collect." },
      { id: "spawn_30", text: "Been aching to punch Fisk in his fat face." },
      { id: "spawn_31", text: "Time to show Fisk whose city this really is…" },
    ],
    respawn: [
      { id: "respawn_1", text: "Khonshu! Watch over me." },
      { id: "respawn_2", text: "Guess Khonshu's got my back after all…" },
      { id: "respawn_3", text: "Back where I started." },
      {
        id: "respawn_4",
        text: "Ghhh… I've came back from far worse than THAT.",
      },
      { id: "respawn_5", text: "Come on, Khonshu! Let me rest!" },
      { id: "respawn_6", text: "Back again? Great." },
      { id: "respawn_7", text: "Still not dead…" },
      { id: "respawn_8", text: "Khonshu: Get up, my Fist." },
      {
        id: "respawn_9",
        text: "At least I didn't wake up in the crazy house again.",
      },
    ],
    ult_ally: [{ id: "ult_ally", text: "Leave them to Khonshu!" }],
    ult_enemy: [{ id: "ult_enemy", text: "The moon haunts you!" }],
    ability2: [
      { id: "ability2_1", text: "Rise… and fall!" },
      { id: "ability2_2", text: "Ankh you very much!" },
      { id: "ability2_3", text: "A gift from Khonshu!" },
      { id: "ability2_4", text: "Time to drain!" },
      { id: "ability2_5", text: "Surrender your strength!" },
      { id: "ability2_6", text: "Khonshu: You need their power." },
    ],
    kill: [
      { id: "kill_1", text: "The power of the moon!" },
      { id: "kill_2", text: "I am the light in the darkness." },
      { id: "kill_3", text: "This was Khonshu's will." },
      { id: "kill_4", text: "Good night." },
      { id: "kill_5", text: "Vengeance is mine." },
      { id: "kill_6", text: "Get up. I'm not done." },
      { id: "kill_7", text: "Vengeance is served." },
      { id: "kill_8", text: "Khonshu never rests." },
    ],
    multikill: [
      { id: "multikill_1", text: "That's three for me!" },
      { id: "multikill_2", text: "One for Steven. One for Jake. One for me." },
      { id: "multikill_3", text: "Three down…" },
      { id: "multikill_4", text: "Five in a row!" },
      { id: "multikill_5", text: "Took out five of them." },
      { id: "multikill_6", text: "Talk about a winning streak!" },
      { id: "multikill_7", text: "Was that everyone? Really?" },
      { id: "multikill_8", text: "Huh. I was just getting started…" },
      { id: "multikill_9", text: "All done. Happy now, Khonshu?" },
    ],
    low_hp: [
      { id: "low_hp_1", text: "Was getting kinda worried there…" },
      { id: "low_hp_2", text: "Whew. Almost didn't make it. Again." },
    ],
    healed: [
      { id: "healed_1", text: "All right. That feels better." },
      { id: "healed_2", text: "Needed that. Thanks." },
      { id: "healed_3", text: "Love battlefield medicine." },
      { id: "healed_4", text: "The wounds are gone. Thanks!" },
      { id: "healed_5", text: "A little pick-me-up." },
      { id: "healed_6", text: "Khonshu: Good, you needed it." },
    ],
  },
} satisfies VoiceScript;

export default script;
